import { AnyAction } from 'redux';
import { Produktlinienname } from '@ps20/bff-models';
import { VhvActions } from '../vhvActions';
import {
  SelectedWertsachensummeChangedAction,
  Wertsachensumme,
} from '../model/wertsachensummen.model';

export const selectedWertsachensummeReducer = function (
  sectionState: Wertsachensumme = null,
  action: AnyAction,
): Wertsachensumme {
  switch (action.type) {
    case VhvActions.SELECTED_WERTSACHENSUMME_CHANGED: {
      const changeAction: SelectedWertsachensummeChangedAction = action;
      const changedWertsachensummeAttributes = changeAction.payload;
      if (changedWertsachensummeAttributes == null) {
        return null;
      }
      return modifyWertsachenSummeBasedOnRange({
        ...sectionState,
        ...changedWertsachensummeAttributes,
      });
    }
    case VhvActions.WERTSACHENSUMMEN_CHANGED: {
      return null;
    }
    default:
      return sectionState;
  }
};

function modifyWertsachenSummeBasedOnRange(wertsachenSumme: Wertsachensumme): {
  produktline: Produktlinienname;
  maxSumme: number;
  editable: boolean;
  summe: number;
  minSumme: number;
} {
  if (wertsachenSumme.summe == null) {
    return wertsachenSumme;
  }
  if (wertsachenSumme.summe < wertsachenSumme.minSumme) {
    return {
      ...wertsachenSumme,
      summe: wertsachenSumme.minSumme,
    };
  }
  if (wertsachenSumme.summe > wertsachenSumme.maxSumme) {
    return {
      ...wertsachenSumme,
      summe: wertsachenSumme.maxSumme,
    };
  }
  return wertsachenSumme;
}
